'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ABN_LENGTH = 11;
var normaliseAbn = function normaliseAbn(abn) {
  var trimmedABN = abn == null ? void 0 : abn.replace(/\s/g, ''); // The input is an ABN, in which case the format should be 99 999 999 999

  if (trimmedABN.length === ABN_LENGTH) {
    return trimmedABN.substring(0, 2) + ' ' + trimmedABN.substring(2, 5) + ' ' + trimmedABN.substring(5, 8) + ' ' + trimmedABN.substring(8);
  }

  return abn;
};
var isValidAbn = function isValidAbn(abn) {
  var VALID_ABN_LENGTH = 11; // strip whitespace from value

  abn = String(abn).replace(/\s+/g, '');

  if (abn.length === VALID_ABN_LENGTH) {
    var weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
    var abnArray = [];

    for (var i = 0; i < abn.length; i++) {
      abnArray[i] = abn.charAt(i);
    } // subtract 1 from the left-most digit
    // @ts-expect-error TS(2362): The left-hand side of an arithmetic operation must... Remove this comment to see the full error message


    abnArray[0] -= 1; // multiply each of the digits by its weighting factor

    for (var _i = 0; _i < abnArray.length; _i++) {
      // @ts-expect-error TS(2362): The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
      abnArray[_i] *= weights[_i];
    } // sum all the digits


    var abnSum = 0;

    for (var _i2 = 0; _i2 < abnArray.length; _i2++) {
      // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'number'.
      abnSum += abnArray[_i2];
    }

    return abnSum % 89 === 0;
  } else {
    return false;
  }
};

exports.isValidAbn = isValidAbn;
exports.normaliseAbn = normaliseAbn;
